import React, { forwardRef, Ref } from "react";
import { formatDateDisplay, numeralCustom } from "../../../../utils/helpers";
import { isArray } from "lodash";

interface IPrintPBLNH {
  hd: any;
}

function PrintPBLNH({ hd }: IPrintPBLNH, ref: Ref<any>) {
  return (
    <div ref={ref} style={{ width: "614px" }}>
      <table style={{ width: "100%" }}>
        <tbody>
          <tr>
            <td style={{ width: "15%" }}>
              <img
                src="https://api.goodapp.vn/getfile/products/674458387b38488ffa484e71_1737452752437_348445341_3001963696614090_3059962296448761742_n.jpg.webp?access_token=flex.public.token"
                alt=""
                style={{ width: "100%", height: "150px", objectFit: "contain" }}
              />
            </td>
            <td
              style={{
                width: "70%",
                paddingLeft: "10px",
                paddingRight: "30px",
              }}
            >
              <span style={{ fontWeight: 600 }}>Trạm Dừng Chân Lắc Chuông</span>
              <br />
              <span>
                Cây số 94 QL20, Túc Trưng, Huyện Định Quán , Tỉnh Đồng Nai
              </span>
              <br />
              <span>Hotline: 036 484 5060</span>
              <br />
              <span>Website: www.bus94.com</span>
            </td>
            <td style={{ width: "15%" }}>
              <div
                style={{
                  width: "80%",
                  paddingTop: "80%",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    zIndex: 10,
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    borderRadius: "50%",
                    border: "1px solid",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "25px",
                  }}
                >
                  {hd?.ten_ban}
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <p
        style={{
          fontSize: "18px",
          fontWeight: 600,
          textAlign: "center",
          margin: "10px 0px",
        }}
      >
        HÓA ĐƠN BÁN HÀNG
      </p>
      <table style={{ width: "100%" }}>
        <tr>
          <td style={{ width: "50%", textAlign: "left" }}>
            <span>
              Ngày: {formatDateDisplay(hd?.ngay_ct, "DD/MM/YYYY HH:mm")}
            </span>
          </td>
          <td style={{ width: "50%", textAlign: "right" }}>
            <span>Thu ngân: {hd?.name_user_created}</span>
          </td>
        </tr>
      </table>
      {/* Chi tiết đơn hàng */}
      <table
        style={{ width: "100%", marginTop: "10px", borderCollapse: "collapse" }}
        border={1}
      >
        <thead>
          <th
            style={{
              fontWeight: 600,
              textAlign: "center",
              padding: "2px",
              width: "10%",
            }}
          >
            SL
          </th>
          <th
            style={{
              fontWeight: 600,
              textAlign: "right",
              padding: "2px",
              width: "30%",
            }}
          >
            Giá
          </th>
          <th
            style={{
              fontWeight: 600,
              textAlign: "right",
              padding: "2px",
              width: "30%",
            }}
          >
            CK
          </th>
          <th
            style={{
              fontWeight: 600,
              textAlign: "right",
              padding: "2px",
              width: "30%",
            }}
          >
            T.Tiền
          </th>
        </thead>
        {isArray(hd?.details) &&
          hd?.details?.length > 0 &&
          hd?.details.map((detail: any) => {
            return (
              <tr key={detail?._id}>
                <td colSpan={4}>
                  <span style={{ paddingLeft: "10px" }}>{detail?.ten_vt}</span>
                  <br />
                  <table style={{ width: "100%" }}>
                    <tr>
                      <td
                        style={{
                          width: "10%",
                          textAlign: "center",
                          padding: "2px",
                        }}
                      >
                        {detail?.sl_order}
                      </td>
                      <td
                        style={{
                          textAlign: "right",
                          padding: "2px",
                          width: "30%",
                        }}
                      >
                        {numeralCustom(detail?.gia_ban_nt).format()}
                      </td>
                      <td
                        style={{
                          textAlign: "right",
                          padding: "2px",
                          width: "30%",
                        }}
                      >
                        {numeralCustom(detail?.tien_ck_nt).format()}
                      </td>
                      <td
                        style={{
                          textAlign: "right",
                          padding: "2px",
                          width: "30%",
                        }}
                      >
                        {numeralCustom(detail?.tien_xuat_nt).format()}
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            );
          })}
      </table>
      <table style={{ width: "100%", marginTop: "10px", marginBottom: "5px" }}>
        <tbody>
          <tr>
            <td style={{ width: "50%" }}>
              <span>Tổng số lượng:</span>
            </td>
            <td style={{ width: "50%" }}>
              <span style={{ textAlign: "right" }}>{hd?.t_sl}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <table style={{ width: "100%", marginBottom: "5px" }}>
        <tbody>
          <tr>
            <td style={{ width: "50%" }}>
              <span>Tiền hàng</span>
            </td>
            <td style={{ width: "50%" }}>
              <span style={{ textAlign: "right" }}>
                {numeralCustom(hd?.t_tien_nt).format()}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <table style={{ width: "100%", marginBottom: "5px" }}>
        <tbody>
          <tr>
            <td style={{ width: "50%" }}>
              <span>Giảm giá</span>
            </td>
            <td style={{ width: "50%" }}>
              <span style={{ textAlign: "right" }}>
                {numeralCustom(hd?.t_ck_nt).format()}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <table style={{ width: "100%", marginBottom: "5px" }}>
        <tbody>
          <tr>
            <td style={{ width: "50%" }}>
              <span>Tổng tiền</span>
            </td>
            <td style={{ width: "50%" }}>
              <span style={{ textAlign: "right" }}>
                {numeralCustom(hd?.t_tt_nt).format()}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <p style={{ textAlign: "center", fontStyle: "italic" }}>
        Xin cảm ơn quý khách! Thank you!
      </p>
    </div>
  );
}

export default forwardRef(PrintPBLNH);
